export default __webpack_public_path__ + "static/media/mark-as-resolved-tick.7a122993.svg";